import { CeoSubmittedFormPayload } from 'types/services/CeoSubmittedForm';

import { Question } from './CeoSurvey.props';

export function ceoSurveyToSubmittedForm(
  form: Question[],
  enrollmentId: string
): CeoSubmittedFormPayload {
  return {
    enrollmentId,
    questions: form,
  };
}
